import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setErr(msg);
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md samaaj-card p-8" data-testid="login-card">
        <div className="text-xs tracking-[0.2em] uppercase font-bold text-[#D95A41]">Welcome back</div>
        <h1 className="font-heading text-4xl mt-2 text-[#1C1B1A]">Log in to Anveshan</h1>
        <p className="text-sm text-[#5C564D] mt-2">Your community services, one login away.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-semibold text-[#5C564D]">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#E5D9CC] bg-[#F9F6F0] focus:outline-none focus:border-[#D95A41]"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-[#5C564D]">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#E5D9CC] bg-[#F9F6F0] focus:outline-none focus:border-[#D95A41]"
              placeholder="••••••••"
            />
          </div>
          {err && <div className="text-sm text-red-700" data-testid="login-error">{err}</div>}
          <button data-testid="login-submit" disabled={busy} className="samaaj-btn-primary w-full">
            {busy ? "Logging in…" : "Log in"}
          </button>
        </form>
        <div className="mt-6 text-sm text-center text-[#5C564D]">
          New here? <Link to="/register" data-testid="link-register" className="text-[#D95A41] font-semibold link-underline">Create an account</Link>
        </div>
      </div>
    </div>
  );
}
